import { useI18n } from "@common/hooks/i18n";
import React from "react";

export interface DoneProps {}

export default (props: DoneProps) => {
  const i18n = useI18n();

  return (
    <div className="success_message">
      <span className="far fa-check"></span>
      <h3>{i18n.unsubscribeFeedbackSuccess}</h3>
    </div>
  );
};
